import React from "react";
import "./style.scss";
import { MdAddShoppingCart, MdArrowBackIosNew, MdOutlineCancel } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { AssortGroup } from "../../../models/AssortGroup";
import usePasses from "../../Passes/hooks/usePasses";
import CalendarPass from "../../Passes/CalendarPass";
import useBasketManager from "../../SaleMovie/CinemaHall/hooks/useBasketManager";
import useParentMessage from "../../../../utils/hooks/useParentMessage";
import { useTranslation } from "react-i18next";
import { State } from "../../../store";
import { useSelector } from "react-redux";
import { setAddToBasketMessage } from "../../../store/alerts/alertsActions";
import { FINALIZE_PAGE } from "../../../routes";

interface IProps {
  item: AssortGroup;
  handleOpenPassModal: () => void;
}

const ModalWindowPass: React.FC<IProps> = ({ item, handleOpenPassModal }) => {
  const { selectedDate, setDateBetween } = usePasses();
  const { handleAddBasketLimited } = useBasketManager();
  const { scrollToTop } = useParentMessage();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);

  const finalizeFunction = () => {
    if (saleConfiguration.popupAfterAddTicket === true) {
      dispatch(setAddToBasketMessage(t("dodano_do_koszyka")));
      //  scrollToId('AddToBasketMessage')
    }
   
    if(saleConfiguration.popupAfterAddTicket === false){
      setTimeout(() => {
        navigate(FINALIZE_PAGE)
      }, 100);
    }
  }

  return (
    <React.Fragment>
      <div className="modal-window-pass">
        <div className="modal-window-header flex-start-center">
          <button
            onClick={() => {
              handleOpenPassModal();
            }}
            className="back-button flex-start-center"
          >
            <MdArrowBackIosNew className="back-button-icon" />
            <b>{t("wroc")}</b>
          </button>
          <h1>{t("wybierz_date_rozpoczecia")}</h1>
        </div>
        <div className="pass-details">
          <b>{item.name}</b>
          <article
            dangerouslySetInnerHTML={{ __html: item.description }}
          ></article>
        </div>
        <div className="pass-body">
          <CalendarPass selectedDate={selectedDate} setDateBetween={setDateBetween} item={item} />

          <div className="flex-column">
            <button
              onClick={() => {
                handleAddBasketLimited(item, 1, selectedDate);
                setTimeout(() => {
                  handleOpenPassModal();
                  scrollToTop();
                }, 200);
                setTimeout(() => {
                  finalizeFunction();
                }, 400)

              }}
              className="full-button button medium padding-medium button-fill-main move-up"
            >
              {t("dodaj_do_koszyka")}
              <MdAddShoppingCart className="icon" />
            </button>
            <button
              onClick={() => {
                handleOpenPassModal();
                scrollToTop();
              }}
              className="full-button button medium padding-medium button-text-main move-up"
            >
              {t("rezygnuje")}
              <MdOutlineCancel className="icon" />
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ModalWindowPass;
function dispatch(arg0: any) {
  throw new Error("Function not implemented.");
}

